import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import BlockTypes from '../../types/BlockTypes';
import { normalizeNode, shouldNotBeEmpty, shouldBeAtRoot, shouldMergeWithSimilarSiblings, shouldHaveChildrenOfType } from '../utils/NormalizationHelper';
import renderBlocks from '../utils/renderBlocks';
import makeKeyboardBlockShortcut from '../utils/makeKeyboardBlockShortcut';
import makeMarkdownBlockShortcut from '../utils/makeMarkdownBlockShortcut';
import makeToolbarButton, { EXPANDED_SELECTION, BASIC_INSERTION, EXPANDED_INSERTION } from '../utils/makeToolbarButton';
import { QuoteIcon } from '../../components/Icons';
import './style.css';
export default (function () {
  var _html, _markdown, _renderBlocks;

  return [normalizeNode(BlockTypes.QUOTES, [shouldNotBeEmpty, shouldBeAtRoot, shouldMergeWithSimilarSiblings, [shouldHaveChildrenOfType, BlockTypes.QUOTE]]), {
    serializers: {
      html: (_html = {}, _defineProperty(_html, BlockTypes.QUOTES, 'blockquote'), _defineProperty(_html, BlockTypes.QUOTE, 'p'), _html),
      markdown: (_markdown = {}, _defineProperty(_markdown, BlockTypes.QUOTES, function (_ref) {
        var children = _ref.children;
        return "".concat(children.replace('\n', '  \n'), "\n");
      }), _defineProperty(_markdown, BlockTypes.QUOTE, function (_ref2) {
        var children = _ref2.children;
        return "> ".concat(children, "\n");
      }), _markdown)
    }
  }, renderBlocks((_renderBlocks = {}, _defineProperty(_renderBlocks, BlockTypes.QUOTES, function (props) {
    return React.createElement("blockquote", Object.assign({
      className: "blockquote"
    }, props.attributes), props.children);
  }), _defineProperty(_renderBlocks, BlockTypes.QUOTE, function (props) {
    return React.createElement("div", props.attributes, props.children);
  }), _renderBlocks)), makeToolbarButton(BlockTypes.QUOTE, {
    icon: QuoteIcon,
    title: 'Quote',
    visibility: EXPANDED_SELECTION | BASIC_INSERTION | EXPANDED_INSERTION,
    canApply: function canApply(editor) {
      return editor.isMutableBlock();
    },
    isActive: function isActive(editor) {
      return editor.isActiveBlock(BlockTypes.QUOTE);
    },
    onApply: function onApply(editor) {
      return editor.toggleBlock(BlockTypes.QUOTE);
    }
  }), makeKeyboardBlockShortcut('mod+shift+.', BlockTypes.QUOTE), makeMarkdownBlockShortcut(/^(>)$/, BlockTypes.QUOTE)];
});